export const COMPANY_NAME = "MEHRABIAN HEATING & COOLING LLC";
export const COMPANY_SHORT = "Mehrabian Heating & Cooling";
export const COMPANY_INITIALS = "MHC";
export const COMPANY_ADDRESS_FULL = "16010 Wyandotte St, Van Nuys, CA 91406-3038";
export const COMPANY_LOCATION = "Van Nuys, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=16010%20Wyandotte%20St%2C%20Van%20Nuys%2C%20CA%2091406-3038";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Heating & Cooling" },
  { "label": "Service area", "value": "Los Angeles County" },
  { "label": "Location", "value": "Van Nuys, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "MEHRABIAN HEATING & COOLING LLC" },
  { "label": "Location", "value": "Van Nuys, CA" },
  { "label": "Address", "value": "16010 Wyandotte St, Van Nuys, CA 91406-3038" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Heating", "body": "A clear, welcoming overview of the company’s heating focus." },
  { "icon": "✦", "title": "Cooling", "body": "A concise directory profile for the company’s cooling focus." },
  { "icon": "✿", "title": "Local presence", "body": "Public business location in Van Nuys, California." },
  { "icon": "❍", "title": "Plan your visit", "body": "Use the map link to locate the public business address." },
];
